import { ErrorHandler, Injectable } from '@angular/core';
import { isStaleBundleError, reloadForStaleBundle } from 'app/core/version/stale-bundle';

/**
 * Custom error handler that suppresses known ApexCharts teardown errors.
 *
 * ng-apexcharts schedules chart hydration via AsapScheduler (microtask).
 * When the router destroys a component before that microtask fires,
 * ApexCharts tries to access DOM elements that no longer exist, throwing:
 *   - "Element not found"
 *   - "Cannot read properties of undefined (reading 'node')"
 *
 * These errors are harmless — the chart was being torn down anyway.
 * All other errors are forwarded to the default console handler.
 */
@Injectable()
export class ApexSafeErrorHandler implements ErrorHandler {

    handleError(error: any): void {
        const msg = error?.message ?? error?.toString?.() ?? '';

        // Lazy-chunk fetch failed — the daily deploy replaced the hashed
        // bundles this tab was built against. A reload pulls the new build.
        if (isStaleBundleError(error) && reloadForStaleBundle()) {
            return;
        }

        // Suppress known ApexCharts teardown errors
        if (
            msg.includes('Element not found') ||
            (msg.includes('Cannot read properties of undefined') && msg.includes('node'))
        ) {
            // Silently ignore — chart was destroyed during navigation
            return;
        }

        // Default behavior: log to console
        console.error(error);
    }
}
